"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LAB_ROUTES = exports.LAB_REGISTER = exports.LAB_LOGIN = exports.CLOUDAPI_SECURED_SEND_NEWSLETTER = exports.CLOUDAPI_SECURED_PUBLISH_WIKI = exports.CLOUDAPI_SECURED_PUBLISH_PASSAGE = exports.CLOUDAPI_SECURED_PUBLISH_PAGE = exports.CLOUDAPI_SECURED_PUBLISH_IMAGE = exports.CLOUDAPI_SECURED_PUBLISH_COURSE = exports.CLOUDAPI_SECURED_PUBLISH_CATEGORY = exports.CLOUDAPI_SECURED_PUBLISH_BULLETIN = exports.CLOUDAPI_SECURED_PUBLISH_ASPECT = exports.CLOUDAPI_PUBLIC_UNSUBSCRIBE_FREE_COURSE = exports.CLOUDAPI_PUBLIC_UNSUBSCRIBE_EMAIL = exports.CLOUDAPI_PUBLIC_SUBSCRIBE_FREE_COURSE = exports.CLOUDAPI_PUBLIC_SUBMIT_QUESTIONNAIRE = exports.CLOUDAPI_PUBLIC_LIST_PUBLISHED_PAGES = exports.CLOUDAPI_PUBLIC_LIST_PUBLISHED_COURSES = exports.CLOUDAPI_PUBLIC_LIST_PUBLISHED_ABSTRACTS = exports.CLOUDAPI_PUBLIC_IMAGE = exports.CLOUDAPI_PUBLIC_GET_REFERENCE_TOOLTIP = exports.CLOUDAPI_PUBLIC_GET_PYQML_HOME = exports.CLOUDAPI_PUBLIC_GET_PUBLISHED_WIKI = exports.CLOUDAPI_PUBLIC_GET_PUBLISHED_PASSAGE = exports.CLOUDAPI_PUBLIC_GET_PUBLISHED_PAGE = exports.CLOUDAPI_PUBLIC_GET_PAYWALLED_PAGE_WITH_EMAILTOKEN = exports.CLOUDAPI_PUBLIC_GET_COURSE = exports.CLOUDAPI_PUBLIC_GET_CATEGORY = exports.CLOUDAPI_PUBLIC_CREATE_CHECKOUT_SESSION = exports.CLOUDAPI_PRIVATE_UPGRADE_SUBSCRIPTION = exports.CLOUDAPI_PRIVATE_SUBSCRIBE_BULLETIN = exports.CLOUDAPI_PRIVATE_GET_PAYWALLED_PAGE = exports.CLOUDAPI_PRIVATE_GET_EMAIL_SUBSCRIPTION = exports.CLOUDAPI_PRIVATE_GET_DOWNLOAD_LINK = exports.CLOUDAPI_PRIVATE_CANCEL_SUBSCRIPTION = exports.CLOUDAPI_AUTH_REQUESTLOGIN = exports.CLOUDAPI_AUTH_LOGIN = exports.CLOUDAPI_ANALYTICS_LOGIN = exports.CLOUDAPI_ANALYTICS_LISTDATA = exports.CLOUDAPI_ANALYTICS_ANALYZE = exports.BLOG_WIKI = exports.BLOG_UNSUBSCRIBE = exports.BLOG_TUTORIALS = exports.BLOG_TEASERCOURSE = exports.BLOG_TAMQUESTIONNAIRE = exports.BLOG_SUBSCRIBE = exports.BLOG_SETTINGS = exports.BLOG_PROJECTS = exports.BLOG_PROJECTCOURSE = exports.BLOG_PRIVACY = exports.BLOG_POSTS = exports.BLOG_LOGIN = exports.BLOG_HOME = exports.BLOG_EXPLORE = exports.BLOG_DRAFT = exports.BLOG_COURSES = exports.BLOG_COURSE = exports.BLOG_COMICS = exports.BLOG_CATEGORY = exports.BLOG_BOOKS = exports.BLOG_ALGORITHMS = exports.BLOG_ALGORITHMCOURSE = exports.BLOG_ABOUT = exports.AUTHOR_SETTINGS = exports.AUTHOR_ROUTES = exports.AUTHOR_REGISTER = exports.AUTHOR_LOGIN = exports.API_UPDATE_TAG = exports.API_UPDATE_SOURCE = exports.API_UPDATE_IMAGE = exports.API_UPDATE_BLOCK = exports.API_SAVE_ACTIONS = exports.API_RELOAD_SOURCEFILE = exports.API_PUBLISH_TAG = exports.API_PUBLISH_BLOCK = exports.API_PROMPT_LLM = exports.API_PRIVATE_UPLOAD_SOURCEFILE = exports.API_PRIVATE_LIST_FILES = exports.API_PRIVATE_GET_FILE = exports.API_PRIVATE_GETSUBSCRIPTION = exports.API_LIST_TAGS = exports.API_LIST_SOURCES = exports.API_LIST_IMAGES = exports.API_LIST_BLOCKS = exports.API_GET_SOURCEFILE_URL = exports.API_GET_IMAGE_DATA = exports.API_GET_BLOCK = exports.API_DELETE_SOURCE = exports.API_DELETE_IMAGE = exports.API_DELETE_BLOCK = exports.API_CREATE_TAG = exports.API_CREATE_SOURCE = exports.API_CREATE_IMAGE = exports.API_CREATE_BLOCK_REFERENCE = exports.API_CREATE_BLOCK = exports.API_AUTH_SIGNUP = exports.API_AUTH_REQUESTLOGIN = exports.API_AUTH_LOGIN = exports.ANALYTICS_LOGIN = exports.ANALYTICS_HOME = void 0;
exports.SERVICE_TRIGGER = exports.SERVICE_STEP = exports.SERVICE_RENDERER = exports.SERVICE_MAILER = exports.SERVICE_ANALYZE = exports.QUERY_BLOG_SESSIONID = exports.PYSERVER_RUN_QUERY = exports.PYSERVER_PROCESS_SOURCE_FILE = exports.PYSERVER_PRINT_PDF = exports.PYSERVER_FIND_SOURCE_METADATA = exports.PYSERVER_AI = exports.PARAM_SLUG = exports.PARAM_PASSAGESLUG = exports.LAB_SETTINGS = void 0;
/** 
 * Routes of the Analytics Application
 */
const ANALYTICS_HOME = exports.ANALYTICS_HOME = '/';
const ANALYTICS_LOGIN = exports.ANALYTICS_LOGIN = '/login';

/**
 * App Routes of the Blog-application
 */
const BLOG_HOME = exports.BLOG_HOME = '/';
const BLOG_CATEGORY = exports.BLOG_CATEGORY = '/category';
const BLOG_SUBSCRIBE = exports.BLOG_SUBSCRIBE = '/subscribe';
const BLOG_PRIVACY = exports.BLOG_PRIVACY = '/privacy';
const BLOG_ABOUT = exports.BLOG_ABOUT = '/about';
const BLOG_SETTINGS = exports.BLOG_SETTINGS = '/settings';
const BLOG_BOOKS = exports.BLOG_BOOKS = '/books';
const BLOG_POSTS = exports.BLOG_POSTS = '/posts';
const BLOG_COMICS = exports.BLOG_COMICS = '/comics';
const BLOG_TUTORIALS = exports.BLOG_TUTORIALS = '/tutorials';
const BLOG_COURSES = exports.BLOG_COURSES = '/modules';
const BLOG_ALGORITHMS = exports.BLOG_ALGORITHMS = '/algorithms';
const BLOG_PROJECTS = exports.BLOG_PROJECTS = '/projects';
const BLOG_EXPLORE = exports.BLOG_EXPLORE = '/explore';
const BLOG_TAMQUESTIONNAIRE = exports.BLOG_TAMQUESTIONNAIRE = '/tam-questionnaire';
const BLOG_WIKI = exports.BLOG_WIKI = '/wiki';
const BLOG_DRAFT = exports.BLOG_DRAFT = '/draft';
const BLOG_COURSE = exports.BLOG_COURSE = '/module';
const BLOG_TEASERCOURSE = exports.BLOG_TEASERCOURSE = '/teaser';
const BLOG_ALGORITHMCOURSE = exports.BLOG_ALGORITHMCOURSE = '/algorithm';
const BLOG_PROJECTCOURSE = exports.BLOG_PROJECTCOURSE = '/project';
const BLOG_LOGIN = exports.BLOG_LOGIN = '/login';
const BLOG_UNSUBSCRIBE = exports.BLOG_UNSUBSCRIBE = '/unsubscribe';

/**
 * Parameters of the Blog-application
 */
const PARAM_SLUG = exports.PARAM_SLUG = 'slug';
const PARAM_PASSAGESLUG = exports.PARAM_PASSAGESLUG = 'passageslug';

/**+
 * name of the query param
 */
const QUERY_BLOG_SESSIONID = exports.QUERY_BLOG_SESSIONID = 'session_id';
const CLOUDAPI_SECURED_PUBLISH_PAGE = exports.CLOUDAPI_SECURED_PUBLISH_PAGE = "/api/secured/publishPage";
const CLOUDAPI_SECURED_PUBLISH_IMAGE = exports.CLOUDAPI_SECURED_PUBLISH_IMAGE = "/api/secured/publishImage";
const CLOUDAPI_SECURED_PUBLISH_CATEGORY = exports.CLOUDAPI_SECURED_PUBLISH_CATEGORY = "/api/secured/publishCategory";
const CLOUDAPI_SECURED_PUBLISH_COURSE = exports.CLOUDAPI_SECURED_PUBLISH_COURSE = "/api/secured/publishCourse";
const CLOUDAPI_SECURED_PUBLISH_BULLETIN = exports.CLOUDAPI_SECURED_PUBLISH_BULLETIN = "/api/secured/publishBulletin";
const CLOUDAPI_SECURED_SEND_NEWSLETTER = exports.CLOUDAPI_SECURED_SEND_NEWSLETTER = "/api/secured/sendNewsletter";
const CLOUDAPI_SECURED_PUBLISH_WIKI = exports.CLOUDAPI_SECURED_PUBLISH_WIKI = "/api/secured/publishWiki";
const CLOUDAPI_SECURED_PUBLISH_ASPECT = exports.CLOUDAPI_SECURED_PUBLISH_ASPECT = "/api/secured/publishAspect";
const CLOUDAPI_SECURED_PUBLISH_PASSAGE = exports.CLOUDAPI_SECURED_PUBLISH_PASSAGE = "/api/secured/publishPassage";
const CLOUDAPI_PUBLIC_LIST_PUBLISHED_ABSTRACTS = exports.CLOUDAPI_PUBLIC_LIST_PUBLISHED_ABSTRACTS = "/api/public/listPublishedAbstracts";
const CLOUDAPI_PUBLIC_LIST_PUBLISHED_PAGES = exports.CLOUDAPI_PUBLIC_LIST_PUBLISHED_PAGES = "/api/public/listPublishedPages";
const CLOUDAPI_PUBLIC_LIST_PUBLISHED_COURSES = exports.CLOUDAPI_PUBLIC_LIST_PUBLISHED_COURSES = "/api/public/listPublishedCourses";
const CLOUDAPI_PUBLIC_GET_COURSE = exports.CLOUDAPI_PUBLIC_GET_COURSE = "/api/public/getCourse";
const CLOUDAPI_PUBLIC_GET_PUBLISHED_PAGE = exports.CLOUDAPI_PUBLIC_GET_PUBLISHED_PAGE = "/api/public/getPublishedPage";
const CLOUDAPI_PUBLIC_SUBMIT_QUESTIONNAIRE = exports.CLOUDAPI_PUBLIC_SUBMIT_QUESTIONNAIRE = "/api/public/submitQuestionnaire";
const CLOUDAPI_PUBLIC_GET_REFERENCE_TOOLTIP = exports.CLOUDAPI_PUBLIC_GET_REFERENCE_TOOLTIP = "/api/public/getReferenceTooltip";
const CLOUDAPI_PUBLIC_GET_PUBLISHED_PASSAGE = exports.CLOUDAPI_PUBLIC_GET_PUBLISHED_PASSAGE = "/api/public/getPublishedPassage";
const CLOUDAPI_PUBLIC_GET_PUBLISHED_WIKI = exports.CLOUDAPI_PUBLIC_GET_PUBLISHED_WIKI = "/api/public/getPublishedWiki";
const CLOUDAPI_PUBLIC_GET_PYQML_HOME = exports.CLOUDAPI_PUBLIC_GET_PYQML_HOME = "/api/public/getPyQMLHome";
const CLOUDAPI_PUBLIC_GET_CATEGORY = exports.CLOUDAPI_PUBLIC_GET_CATEGORY = "/api/public/getCategory";
const CLOUDAPI_PRIVATE_GET_PAYWALLED_PAGE = exports.CLOUDAPI_PRIVATE_GET_PAYWALLED_PAGE = "/api/private/getPaywalledPage";
const CLOUDAPI_PRIVATE_GET_DOWNLOAD_LINK = exports.CLOUDAPI_PRIVATE_GET_DOWNLOAD_LINK = "/api/private/getDownloadLink";
const CLOUDAPI_PRIVATE_GET_EMAIL_SUBSCRIPTION = exports.CLOUDAPI_PRIVATE_GET_EMAIL_SUBSCRIPTION = "/api/private/getEmailSubscription";
const CLOUDAPI_PRIVATE_SUBSCRIBE_BULLETIN = exports.CLOUDAPI_PRIVATE_SUBSCRIBE_BULLETIN = "/api/private/subscribeBulletin";
const CLOUDAPI_PRIVATE_CANCEL_SUBSCRIPTION = exports.CLOUDAPI_PRIVATE_CANCEL_SUBSCRIPTION = "/api/private/cancelSubscription";
const CLOUDAPI_PRIVATE_UPGRADE_SUBSCRIPTION = exports.CLOUDAPI_PRIVATE_UPGRADE_SUBSCRIPTION = "/api/private/upgradeSubscription";
const CLOUDAPI_PUBLIC_SUBSCRIBE_FREE_COURSE = exports.CLOUDAPI_PUBLIC_SUBSCRIBE_FREE_COURSE = "/api/public/subscribeFreeCourse";
const CLOUDAPI_PUBLIC_UNSUBSCRIBE_FREE_COURSE = exports.CLOUDAPI_PUBLIC_UNSUBSCRIBE_FREE_COURSE = "/api/public/unsubscribeFreeCourse";
const CLOUDAPI_PUBLIC_UNSUBSCRIBE_EMAIL = exports.CLOUDAPI_PUBLIC_UNSUBSCRIBE_EMAIL = "/api/public/unsubscribeEmail";
const CLOUDAPI_PUBLIC_CREATE_CHECKOUT_SESSION = exports.CLOUDAPI_PUBLIC_CREATE_CHECKOUT_SESSION = "/api/public/createCheckoutSession";
const CLOUDAPI_PUBLIC_IMAGE = exports.CLOUDAPI_PUBLIC_IMAGE = "/api/public/image";
const CLOUDAPI_PUBLIC_GET_PAYWALLED_PAGE_WITH_EMAILTOKEN = exports.CLOUDAPI_PUBLIC_GET_PAYWALLED_PAGE_WITH_EMAILTOKEN = "/api/public/getPaywalledPageWithEmailToken";
const CLOUDAPI_ANALYTICS_LOGIN = exports.CLOUDAPI_ANALYTICS_LOGIN = "/api/analytics/login";
const CLOUDAPI_ANALYTICS_ANALYZE = exports.CLOUDAPI_ANALYTICS_ANALYZE = "/api/analytics/analyze";
const CLOUDAPI_ANALYTICS_LISTDATA = exports.CLOUDAPI_ANALYTICS_LISTDATA = "/api/analytics/listData";

/**
 * sign up as a new user
 */
//export const CLOUDAPI_AUTH_SIGNUP = '/api/auth/signup';
const CLOUDAPI_AUTH_REQUESTLOGIN = exports.CLOUDAPI_AUTH_REQUESTLOGIN = '/api/auth/requestlogin';

/**
 * sign in as an existing user
 */
const CLOUDAPI_AUTH_LOGIN = exports.CLOUDAPI_AUTH_LOGIN = '/api/auth/login';

/**
 * App Routes of the Lab-application
 */
const LAB_REGISTER = exports.LAB_REGISTER = '/signup';
const LAB_LOGIN = exports.LAB_LOGIN = '/login';
const LAB_SETTINGS = exports.LAB_SETTINGS = '/setting';
const LAB_ROUTES = exports.LAB_ROUTES = [LAB_REGISTER, LAB_LOGIN, LAB_SETTINGS];

/**
 * App Routes of the Author-application
 */
const AUTHOR_REGISTER = exports.AUTHOR_REGISTER = '/signup';
const AUTHOR_LOGIN = exports.AUTHOR_LOGIN = '/login';
const AUTHOR_SETTINGS = exports.AUTHOR_SETTINGS = '/setting';
const AUTHOR_ROUTES = exports.AUTHOR_ROUTES = [AUTHOR_REGISTER, AUTHOR_LOGIN, AUTHOR_SETTINGS];

/**
 * sign up as a new user
 */
const API_AUTH_SIGNUP = exports.API_AUTH_SIGNUP = '/api/auth/signup';

/**
 * sign in as an existing user
 */
const API_AUTH_LOGIN = exports.API_AUTH_LOGIN = '/api/auth/login';

/**
 * serialize the actions performed in the workspace
 */
const API_SAVE_ACTIONS = exports.API_SAVE_ACTIONS = '/api/private/saveActions';
const API_PRIVATE_UPLOAD_SOURCEFILE = exports.API_PRIVATE_UPLOAD_SOURCEFILE = '/api/private/uploadSourceFile';
const API_PRIVATE_LIST_FILES = exports.API_PRIVATE_LIST_FILES = '/api/private/listFiles';
const API_PRIVATE_GET_FILE = exports.API_PRIVATE_GET_FILE = '/api/private/getFile';
const API_PROMPT_LLM = exports.API_PROMPT_LLM = '/api/private/promptLlm';

/**
 * work with blocks
 */
const API_LIST_BLOCKS = exports.API_LIST_BLOCKS = '/api/private/listBlocks';
const API_CREATE_BLOCK = exports.API_CREATE_BLOCK = '/api/private/createBlock';
const API_GET_BLOCK = exports.API_GET_BLOCK = '/api/private/getBlock';
const API_UPDATE_BLOCK = exports.API_UPDATE_BLOCK = '/api/private/updateBlock';
const API_CREATE_BLOCK_REFERENCE = exports.API_CREATE_BLOCK_REFERENCE = '/api/private/createBlockReference';
const API_DELETE_BLOCK = exports.API_DELETE_BLOCK = '/api/private/deleteBlock';
const API_PUBLISH_BLOCK = exports.API_PUBLISH_BLOCK = "/api/private/publishBlock";

/**
 * work with sources
 */
const API_CREATE_SOURCE = exports.API_CREATE_SOURCE = '/api/private/createSource';
const API_LIST_SOURCES = exports.API_LIST_SOURCES = '/api/private/listSources';
const API_DELETE_SOURCE = exports.API_DELETE_SOURCE = '/api/private/deleteSource';
const API_UPDATE_SOURCE = exports.API_UPDATE_SOURCE = '/api/private/updateSource';
const API_RELOAD_SOURCEFILE = exports.API_RELOAD_SOURCEFILE = '/api/private/reloadSourceFile';
const API_GET_SOURCEFILE_URL = exports.API_GET_SOURCEFILE_URL = '/api/private/getSourceFileUrl';

/** work with images */
const API_LIST_IMAGES = exports.API_LIST_IMAGES = '/api/private/listImages';
const API_CREATE_IMAGE = exports.API_CREATE_IMAGE = '/api/private/createImage';
const API_DELETE_IMAGE = exports.API_DELETE_IMAGE = '/api/private/deleteImage';
const API_UPDATE_IMAGE = exports.API_UPDATE_IMAGE = '/api/private/updateImage';
const API_GET_IMAGE_DATA = exports.API_GET_IMAGE_DATA = '/api/private/getImageData';

/** tags */
const API_LIST_TAGS = exports.API_LIST_TAGS = '/api/private/listTags';
const API_CREATE_TAG = exports.API_CREATE_TAG = '/api/private/createTag';
const API_UPDATE_TAG = exports.API_UPDATE_TAG = '/api/private/updateTag';
const API_PUBLISH_TAG = exports.API_PUBLISH_TAG = '/api/private/publishTag';

/**
 * request a login otp
 */
const API_AUTH_REQUESTLOGIN = exports.API_AUTH_REQUESTLOGIN = '/api/auth/requestlogin';

/**
 * get the subscription of the current user
 */
const API_PRIVATE_GETSUBSCRIPTION = exports.API_PRIVATE_GETSUBSCRIPTION = '/api/private/getsubscription';

/** PYTHON SERVER API Endpoints */
const PYSERVER_PROCESS_SOURCE_FILE = exports.PYSERVER_PROCESS_SOURCE_FILE = '/pyserver/sources/processSourceFile';
const PYSERVER_FIND_SOURCE_METADATA = exports.PYSERVER_FIND_SOURCE_METADATA = '/pyserver/sources/findSourceMetadata';
const PYSERVER_RUN_QUERY = exports.PYSERVER_RUN_QUERY = '/pyserver/query/run';
const PYSERVER_PRINT_PDF = exports.PYSERVER_PRINT_PDF = '/pyserver/book/printpdf';
const PYSERVER_AI = exports.PYSERVER_AI = '/pyserver/ai/chat';

/**
 * services
 */
const SERVICE_RENDERER = exports.SERVICE_RENDERER = "/api/service/renderer";

// the scheduled service to send newsletters
const SERVICE_STEP = exports.SERVICE_STEP = '/api/service/step';
const SERVICE_MAILER = exports.SERVICE_MAILER = "/api/service/mailer";
const SERVICE_ANALYZE = exports.SERVICE_ANALYZE = "/api/service/analyze";
const SERVICE_TRIGGER = exports.SERVICE_TRIGGER = "/api/service/trigger";